module.exports = __webpack_public_path__ + "static/media/hall_of_fame.e711e6b4.svg";